import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import email from '../../public/images/icons/email.png';
import location from '../../public/images/icons/location.png';
import phone from '../../public/images/icons/phone.png';
import web from '../../public/images/icons/web.png';

import { colors, fontSize } from '../../constants/styleConstants';
import ImageTag from '../ImageTag';
import { addProtocolIfNeed } from '../../utils/common';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    paddingBottom: 5,
  },
  icon: {},
  text: {
    fontSize: fontSize.basic,
    paddingLeft: 12,
  },
  textHidden: {
    fontSize: fontSize.basic,
    paddingLeft: 12,
    opacity: 0.5,
    fontStyle: 'italic',
    margin: 0,
  },

  normal: {
    color: 'inherit',
    display: 'flex',
    '&:hover': {
      color: 'inherit',
    },
  },
  link: {
    color: colors.blueChip,
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
      color: colors.blueChip,
    },
  },
  textRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > div > a > p': {
      display: 'none',
    },
    '& > div:first-child': {
      '& >a > p': {
        display: 'flex !important',
      },
    },
  },
  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    wordBreak: 'break-word',
    '& > div > a > p': {
      display: 'none',
    },
    '& > div:first-child': {
      '& >a > p': {
        display: 'flex !important',
      },
    }
  },
}));

const iconsMap = {
  0: <ImageTag src={phone} alt="phone" />,
  1: <ImageTag src={email} alt="email" />,
  4: <ImageTag src={location} alt="location" />,
  3: <ImageTag src={web} alt="web" />,
};

const IconWithText = ({ items, hideInfo, isProfileContact }) => {
  const classes = useStyles();

  const contactType = get(items, '[0].contactType.id');
  return (
    <div className={classes.root}>
      <span className={classes.icon}>{iconsMap[contactType]}</span>
      <div className={contactType === 0 ? classes.textRow : classes.textColumn}>
        {items.map(item => (
          <div key={item.value}>
            {hideInfo && isProfileContact && (item?.contactType?.id === 0 || item?.contactType?.id === 1) ? (
              <a rel="noopener noreferrer" className={classes.normal}>
                <p className={classes.textHidden}>hidden</p>
              </a>
            ) : (
              <a
                href={addProtocolIfNeed(item.href)}
                target={item.target}
                rel="noopener noreferrer"
                className={item.href ? classes.link : classes.normal}
              >
                <span className={classes.text}>{item.value}</span>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

IconWithText.propTypes = {
  items: PropTypes.array,
  hideInfo: PropTypes.bool,
};

export default IconWithText;
